module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGMAAABjCAMAAAC45U6nAAAARVBMVEXOESb///8cqXEAnmDQ7eKK0rZAt4j1/PkprnrR7uL8/v19zq4IoWWV1706tITh9OyE0LIRpGtQvJLt+fRoxqGm3cgAAABNz31PAAAAyElEQVR4Ae3WRWKEUBAG4TSFu9//pnHX7vjM/N+KXQFPz46JiIiIiIiI/Tw11PiKJNgAi0r5+Qa/0shCjRzyeINQA8Bi8l9oABSeRskLpb2v4qV3G1bzTO37gseaD/8VT5hHy2OdYzx67vXmM/DAOebcMr+Hj/j5RupsjNwa4w2cjdiIP4zhFGvMZnOkAWC2AIurscBql1ZYgntVAbgaEN58N+xW4musjx99sHuF7gwhaqix/7zfaqihhhpqqKGGGmqooYYaalwAyrEpLjszdOAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/uis/assets/images/flags/sy.png
// module id = 640
// module chunks = 0